function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M500 250C500 388.071 388.071 500 250 500C111.929 500 0 388.071 0 250C0 111.929 111.929 0 250 0C388.071 0 500 111.929 500 250Z",
  fill: "#E7A748"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M220.97 127H278.95V140.92H271.99V147.84H278.83V162.91H271.99V183.81H278.83V263.8H272.03V300.84H279.04V343.79H285.92V351.61H293.82V365.56H285.92V380.73H278.93V358.64H271.81V351.78H227.93V358.77H221.06V380.73H214.03V365.68H207V351.55H214.02V343.67H221.05V300.7H227.82V263.75H221.09V183.79H227.86V162.85H221.12V147.82H227.82V140.8H220.97V127Z",
  fill: "#FEFEFE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M293.82 351.61H285.92V343.79H279V300.79H272V263.79H278.8V183.79H272V162.89H278.84V147.84H272V140.92H279V127H293V134H307.93V140.81H330V134H344V140.88H358.93V169.8H351.93V191.66H343.83V198.87H336.9V213.87H329.81V234.87H322.9V256.87H315.8V285.79H307.8V300.79H300.8V315.79H293.8V351.63L293.82 351.61Z",
  fill: "#010101"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M221 127V140.8H227.85V147.8H221.15V162.8H227.89V183.74H221.12V263.74H227.85V300.7H221.08V343.7H214.08V351.58H207.08V314.68H199V300.76H192V285.66H184V256.75H177V235.18H170.12V213.76H163V198.76H155V191.65H148V169.95H141.2V140.88H156.08V134H170V140.83H192V134.16L205.92 133.95V127H221Z",
  fill: "#010101"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M154.98 191.64V198.75H162.99V213.76H170.07V235.18H176.96V256.75H183.96V285.66H191.94V300.76H198.96V314.68H207.03V351.57H198.86V329.59H191.91V322.68H184.97V314.75H176.99V307.67H169.99V300.75H162.99V293.7H155.97V285.71H148.01V278.78H141.09V270.8H134.03V256.83H127.21V228.89H133.93V206.86H140.98V191.64H154.98Z",
  fill: "#FEFEFE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M293.82 351.59V315.77H300.84V300.78H307.84V285.79H315.8V256.87H322.86V234.87H329.76V213.88H336.87V198.87H343.79V191.66H358.84V205.68H365.74V227.66H372.74V256.68H365.88V270.67H358.98V278.69H350.9V285.64H344.01V293.7H336.84V300.84H329.82V307.76H322.81V314.79H314.89V322.78H307.8V329.78H301.08V351.59H293.82Z",
  fill: "#FEFEFE"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M221.06 380.73V358.73H227.93V351.73H271.81V358.59H278.93V380.67H271.88V387.51H264V394.51H236V387.51H227.94V380.7H221L221.06 380.73Z",
  fill: "#010101"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M358.88 140.88H343.95V134H329.91V140.78H307.84V133.97H315.79V125.89H329.73V119.06H343.89V125.76H358.88V140.88Z",
  fill: "#FEFEFE"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M191.97 134.11V140.78H170V133.95H156.09V140.88H141.21V126.93H155.89V119.06H169.99V125.71H183.95V134.11H191.97Z",
  fill: "#FEFEFE"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M155.97 293.7H162.99V300.75H169.99V307.67H176.99V314.75H184.97V322.68H191.91V329.59H198.86V343.85H191.97V336.82H185.04V329.74H177.05V322.84H170.05V314.83H163.05V307.81H155.97V293.7Z",
  fill: "#010101"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M301.08 343.86V329.78H307.8V322.78H314.89V314.79H322.81V307.76H329.82V300.84H336.84V293.7H344.01V307.75H336.99V314.69H329.92V321.78H321.97V329.72H314.95V336.73H307.94V343.86H301.08Z",
  fill: "#010101"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M271.92 380.7H278.97V387.55H271.92V380.7Z",
  fill: "#FEFEFE"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M221.03 380.7H227.92V387.54H221.03V380.7Z",
  fill: "#FEFEFE"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M285.98 263.87H293.72V271.6H285.98V263.87Z",
  fill: "#FEFEFE"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M199.09 263.86H206.91V271.6H199.09V263.86Z",
  fill: "#FEFEFE"
});

function SvgBadger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadger);
export default __webpack_public_path__ + "static/media/Badger.8bcefb8a.svg";
export { ForwardRef as ReactComponent };